import React from 'react';

const alertMessageStyle = {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffc107',
    borderRadius: '4px',
    padding: '12px 16px',
    marginBottom: '20px',
    fontWeight: 'bold',
    color: '#856404',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    whiteSpace: 'pre-line'
}

export default function AlertMessage(props) {
    const { message } = props

    return (
        <div style={alertMessageStyle}>
            {Array.isArray(message) ? message.join('\n') : message}
        </div>
    )
}
